import _ from 'lodash'

const fullName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  return _.chain([firstName, lastName]).compact().uniq().join(' ').value()
}

export default fullName
